import { motion } from "framer-motion";
import {CheckCircle2} from 'lucide-react';

const benefits = [
"Garantia de evoluir do nível básico",
"Se apresentar com segurança",
"Entender conversas do dia a dia",
"Participar de reuniões básicas",
"Viajar sem depender de tradutor",
"Ter base sólida para evoluir"];


export default function PromiseSection() {
  return (
    <section className="relative bg-white md:py-20 overflow-hidden pt-[40px] pb-[40px]">
      {/* Watermark sutil de mapa */}
      <div className="absolute inset-0 opacity-[0.02] bg-[url('https://images.pexels.com/photos/269790/pexels-photo-269790.jpeg?auto=compress&cs=tinysrgb&w=1200')] bg-center bg-no-repeat bg-cover pointer-events-none" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-serif text-3xl md:text-4xl font-bold text-blue-900 text-center mb-10">

          Com o EW Pass, em 6 meses você pode:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
          {benefits.map((b, i) =>
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4, delay: i * 0.08 }}
            className="flex items-center gap-3 bg-blue-50 rounded-xl p-4">

              <CheckCircle2 className="w-6 h-6 text-blue-600 flex-shrink-0" />
              <span className="text-gray-800 text-base font-medium">{b}</span>
            </motion.div>
          )}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center space-y-2">

          <p className="text-gray-600 text-lg">
            Não é promessa vazia de fluência em 30 dias.
          </p>
          <p className="text-blue-900 text-lg font-semibold">
            É um plano estruturado para tirar você do básico de verdade.
          </p>
          <p className="text-gray-600 text-lg">
            Com constância, estrutura e método, o resultado vem.
          </p>

          <a
            href="#cta-final"
            onClick={(e) => { e.preventDefault(); document.getElementById('cta-final')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="cta-button inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg md:text-xl px-10 py-5 rounded-xl shadow-lg shadow-blue-600/30 hover:shadow-blue-600/50 transition-all duration-300 hover:scale-105 animate-pulse-glow mt-8 cursor-pointer"
          >
            <span className="text-2xl">👉</span> Quero viver essa transformação
          </a>
        </motion.div>
      </div>
    </section>);

}